import type { TFunction } from 'i18next'
import { z } from 'zod'

import { ZervantLocale } from '@features/invoices/enums/zervantLocale'
import { ProductType } from '@features/products/enums/productType'

import { getCompanyContactFormSchema } from '../../../../../utils/getCompanyContactFormSchema'
import type { PresetsSettingsFormSchema } from '../types/presetsSettingsFormSchema'

export const getPresetsSettingsFormSchema = (t: TFunction): PresetsSettingsFormSchema =>
  getCompanyContactFormSchema(t).merge(
    z.object({
      currency: z.string(),
      language: z.nativeEnum(ZervantLocale),
      productType: z.nativeEnum(ProductType),
    }),
  )
